import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/Sales/interviews'

export default {
  namespaced: true,
  state: {
    loading: false,
    interviews: {
      data: [],
      grandTotals: {
        daily: 0,
        monthly: 0,
        chartData: {
          series: [],
          labels: [],
        },
      },
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    interviews(state) {
      return state.interviews
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_INTERVIEWS(state, data) {
      state.interviews = data
    },
    /* RESET MUTATIONS */
    RESET_INTERVIEWS(state) {
      state.interviews = {
        data: [],
        grandTotals: {
          daily: 0,
          monthly: 0,
          chartData: {
            series: [],
            labels: [],
          },
        },
      }
    },
  },
  actions: {
    getInterviews({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_INTERVIEWS')
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_INTERVIEWS', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
  },
}
